import React, { JSX } from "react";

type SkillsCardProps = {
  title: string;
  skills?: string[];
  langList?: {
    name: string;
    icon: JSX.Element;
    iconType: string;
    color: string;
  }[];
};

const SkillsCard = ({ skills, title, langList }: SkillsCardProps) => {
  return (
    <div className="p-2 md:p-8 ">
      <h2 className="text-2xl ">{title}</h2>
      <ul className="flex md:flex-wrap md:justify-between md:gap-4 w-full skills list md:text-xl">
        {skills?.map((skill, index) => (
          <li
            key={index}
            className="rounded-3xl h-10 flex justify-center items-center px-4 hover:bg-primary-color hover:text-white transition-all ease-in-out duration-[0.5s]"
          >
            {skill}
          </li>
        ))}{" "}
        {langList?.map((lang, index) => (
          <li
            key={index}
            className="rounded-3xl h-10 flex justify-center items-center px-4 hover:bg-primary-color hover:text-white transition-all ease-in-out duration-[0.5s]"
          >
            {lang.name}
            {lang.icon}{" "}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SkillsCard;
